import React, { useReducer, useCallback, useState } from 'react'
import { Button, StyleSheet, View, Image, Alert, Text, ActivityIndicator, KeyboardAvoidingView, TouchableOpacity, ScrollView, Platform } from 'react-native';
import Card from '../components/Card';
import Input from '../components/Input';
import { useDispatch } from 'react-redux';
import * as authActions from '../store/authActions';
import { withNavigationFocus } from 'react-navigation';
import { StatusBar } from 'expo-status-bar';

const FORM_INPUT_UPDATE = 'FORM_INPUT_UPDATE';

const formReducer = (state, action) => {
    if (action.type === FORM_INPUT_UPDATE) {
      const updatedValues = {
        ...state.inputValues,
        [action.input]: action.value
      };
      const updatedValidities = {
        ...state.inputValidities,
        [action.input]: action.isValid
      };
      let updatedFormIsValid = true;
      for (const key in updatedValidities) {
        updatedFormIsValid = updatedFormIsValid && updatedValidities[key];
      }
      return {
        formIsValid: updatedFormIsValid,
        inputValidities: updatedValidities,
        inputValues: updatedValues
      };
    }
    return state;
  };




const AuthScreen = props => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const dispatch = useDispatch();
    const ref = React.createRef();

    const [formState, dispatchFormState] = useReducer(formReducer, {
        inputValues: {
          email: '',
          password: ''
        },
        inputValidities: {
          email: false,
          password: false
        },
        formIsValid: false
    });

    
    const authHandler = useCallback(async () => {
        if (!formState.formIsValid) {
          Alert.alert('Wrong input', 'Please check the entries', [
            { text: 'OK'}
          ]);
          return;
        }
        setError(null);
        setIsLoading(true);
        try {
            await dispatch(authActions.login(formState.inputValues.email, formState.inputValues.password));
            props.navigation.navigate({routeName: 'Main', key: 'Main', params: { userEmail: formState.inputValues.email}});
        } catch (err) {
          setError(err.message)
          setIsLoading(false)
        }
    }, [dispatch, formState])


    const signupHandler = () => {
        props.navigation.navigate('Signup')
    }

    const inputChangeHandler = useCallback((inputIdentifier, inputValue, inputValidity) => {
        dispatchFormState({
          type: FORM_INPUT_UPDATE,
          value: inputValue,
          isValid: inputValidity,
          input: inputIdentifier
        });
      },
      [dispatchFormState]
    );

    if (!props.isFocused) return null;
    
    return (
      <View style={{flex:1}}>
      <KeyboardAvoidingView contentContainerStyle={{flex:1}} style={{flex:1}} behavior="padding" keyboardVerticalOffset={-220}>
        <ScrollView>
          <View style={{alignItems: 'center'}}>
          <StatusBar style="auto" />
            <View style={styles.imageContainer}>
                <Image style={styles.image} resizeMode="contain" source={require('../assets/afterlife.png')} />
            </View>
            {error && <Card style={styles.errorContainer}>
                 <Text style={styles.errorText}>{error}</Text>
            </Card>}
            <Card style={styles.loginContainer}>
                <View style={styles.formContainer}>
                    <Input
                        id="email"
                        label="Email address"
                        errorText="Please enter a valid email address"
                        keyboardType="email-address"
                        autoCapitalize="none"
                        autoCorrect={false}
                        returnKeyType="next"
                        textContentType="emailAddress"
                        onInputChange={inputChangeHandler}
                        importantForAutofill="yes"
                        required
                        email
                        placeholder="Email"
                        onSubmitEditing={() => { ref.current.focus(); }}
                        blurOnSubmit={false}
                    />
                    <Input
                        id="password"
                        label="Password"
                        errorText="Please enter a valid password"
                        keyboardType="default"
                        autoCapitalize="none"
                        autoCorrect={false}
                        secureTextEntry
                        textContentType="password"
                        returnKeyType="go"
                        onInputChange={inputChangeHandler}
                        required
                        importantForAutofill="yes"
                        placeholder="Password"
                        onSubmitEditing={authHandler}
                        ref={ref}
                    />
                   <View style={styles.forgotPasswordContainer}>
                     <TouchableOpacity onPress={() => {
                       props.navigation.navigate('Reset')
                     }}>
                      <Text style={styles.forgotPasswordText}>Forgot your password?</Text>
                     </TouchableOpacity>
                   </View>
                </View>
                <View style={styles.buttonContainer}>
                    {isLoading 
                    ? <ActivityIndicator size='small' color='#404040' /> 
                    :<Button style={{margin: 10}} title="Login" color='#404040' onPress={authHandler} />}
                    
              </View>
          </Card>
            <Card style={styles.signUpContainer}>
              <View>
                  <Text style={styles.accountText}>Don't have an account yet?</Text>
              </View>
                <Button style={{margin: 10}} title="Sign Up" color='#404040' onPress={signupHandler} />
            </Card>
            </View>
          </ScrollView>  
      </KeyboardAvoidingView>
    </View>
    )
}


export default withNavigationFocus(AuthScreen);

const styles = StyleSheet.create({
    screen: {
        flex: 1
    },
    loginContainer: {
        width: '77%',
        maxWidth: 500
    },
    buttonContainer: {
        width: '100%',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginBottom: 10
    },
    formContainer: {
        marginHorizontal: 15,
        marginTop: 10
    },
    image: {
        width: '100%',
        height: '100%',
    },
    imageContainer: {
        height: 100,
        width: '70%',
        maxWidth: 600,
        marginBottom: 10
    },
    accountText: {
      marginBottom: 4,
      fontSize: 11,
      color: '#404040'
    },
    signUpContainer: {
      width: '77%',
      marginVertical: 25,
      padding: 10,
      alignItems: 'center',
      maxWidth: 500
    },
    forgotPasswordContainer: {
      marginBottom: 5
    },
    forgotPasswordText: {
      fontSize: 10,
      color: '#404040'
    },
    errorContainer: {
      width: '77%',
      marginBottom: 10,
      padding: 5,
      alignItems: 'center',
      maxWidth: 500
    },
    errorText: {
      color: '#d9534f',
      fontSize: 13,
    }
})
